// Référence de navigation GLOBALE (CCT-97) : permet de naviguer depuis un context, hors d'un
// écran — notamment à l'ouverture d'une notification navigateur (message `cc-push-open` du
// service worker), où aucun composant d'écran n'est monté pour porter `useNavigation`.
import { createNavigationContainerRef } from '@react-navigation/native';

export const navigationRef = createNavigationContainerRef<any>();

// Écrans qui vivent dans le stack INTERNE de `DesktopLayout` (celui qui porte le menu et
// l'en-tête). Miroir de `MISSIONS_DETAIL_SCREENS` — les viser à la RACINE les rendait hors du
// layout : menu absent, et l'on se retrouvait avec deux instances du même écran empilées, d'où
// la navigation incohérente entre notifications et mission (CCT-149).
const INNER_SCREENS = [
  'ChapterDetail', 'SceneReader', 'MissionChat', 'Quiz', 'TaskDetail',
  'MissionCards', 'MissionDetail', 'UserStoryDetail', 'UsChat', 'CharacterChat',
  'Chat', 'Notifications', 'Missions', 'Dashboard',
];

const isDesktopWeb = () => typeof window !== 'undefined' && window.innerWidth >= 768;

/** Navigue si le conteneur est prêt (sinon no-op : l'app n'a pas fini de monter). */
export function navigateFromAnywhere(name: string, params?: any): boolean {
  if (!navigationRef.isReady()) return false;
  // Sur desktop web, on passe TOUJOURS par `Main` pour les écrans internes : sinon la même
  // cible s'ouvrait tantôt dans le layout (clic in-app), tantôt à la racine (notification).
  const target = isDesktopWeb() && INNER_SCREENS.includes(name)
    ? ['Main', { screen: name, params }]
    : [name, params];
  // `navigate` est surchargé (name | name+params) : le typage générique ne l'accepte pas ici.
  (navigationRef.navigate as any)(...target);
  return true;
}
